/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanningCycle {
    H1 = 'H1',
    H2 = 'H2',
}
